import { useCheckPermission } from '../useUserRoles';
import { useAdminCheck } from '../useAdminCheck';

/**
 * Hook to check if current user has maintenance page access
 * Uses ROLE_MAINTENANCE permission for access control
 * Admin override: admins always have access
 */
export const useMaintenanceAccess = () => {
  const { isAdmin, isLoading: isAdminLoading } = useAdminCheck();
  const { data: hasAccess = false, isLoading } = useCheckPermission('ROLE_MAINTENANCE');
  
  // Admin override
  if (isAdmin) {
    return {
      hasAccess: true,
      isLoading: isAdminLoading
    };
  }
  
  return {
    hasAccess,
    isLoading
  };
};